"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const axios_retry_1 = __importDefault(require("axios-retry"));
const API = (config) => {
    const instance = axios_1.default.create({
        baseURL: config.baseURL,
        timeout: config.timeout || 15000,
        headers: {
            'content-type': 'application/json'
        }
    });
    instance.interceptors.request.use((c) => __awaiter(void 0, void 0, void 0, function* () {
        if (config.customHeader) {
            for (var pair of config.customHeader.entries()) {
                c.headers[pair[0]] = pair[1];
            }
        }
        return c;
    }));
    instance.interceptors.response.use((response) => {
        return response;
    }, (error) => {
        return Promise.reject(error);
    });
    axios_retry_1.default(instance, {
        retries: config.retryAttemp || 3,
        retryDelay: () => config.retyrInterval || 500,
        shouldResetTimeout: true
    });
    return instance;
};
exports.default = API;
